import Box from 'components/shared/Box'
import styled, { css } from 'styled-components'
import { fadeInOnRender } from 'styles/animations'
import { respondAbove } from 'styles/mediaQueries'

interface WrapperProps {
    isCategoriesError?: boolean
}

export const Wrapper = styled(Box)<WrapperProps>`
    ${({ theme, isCategoriesError }) =>
        !isCategoriesError &&
        css`
            border: 2px solid
                ${theme.mode === 'dark'
                    ? theme.colors.grayscale_100
                    : theme.colors.grayscale_300};
            border-radius: 8px;
            padding: 24px 16px 8px;

            @media ${respondAbove.md} {
                padding: 40px 40px 16px;
            }
        `}
`

export const ContentWrapper = styled(Box)`
    ${fadeInOnRender};
`

export const Creator = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_100};
`
